import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  ref: z.string().optional(),
});

export const Route = createFileRoute("/register")({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ search }) => {
    // Persist referral code in sessionStorage before redirecting
    if (typeof window !== "undefined" && search.ref) {
      try {
        sessionStorage.setItem("alchema_referral_code", search.ref);
      } catch {
        // sessionStorage unavailable (e.g., private browsing quota)
      }
    }
    throw redirect({ to: "/auth/signup" });
  },
  component: () => null,
});
